"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsHandlerRegistrant = void 0;
const react_1 = require("react");
const use_analytics_1 = require("../use-analytics");
function AnalyticsHandlerRegistrant({ context, ...handler }) {
    const { addHandler, removeHandler } = (0, use_analytics_1.useAnalytics)(context);
    (0, react_1.useEffect)(() => {
        addHandler(handler);
        return () => {
            removeHandler(handler);
        };
    }, [addHandler, removeHandler, handler]);
    return null;
}
exports.AnalyticsHandlerRegistrant = AnalyticsHandlerRegistrant;
//# sourceMappingURL=index.js.map